import { many, attr} from 'redux-orm';
import Model from '../base-model';
import invoiceReducers from './invoice.reducer';
import { invoiceActions } from './invoice.action';

/**
 * Invoice
 * @typedef {Object} Invoice
 * @property {string} id
 * @property {InvoiceItem[]} invoiceItems
 * @property {number} discount
 * @property {number} amount
 * @property {boolean} isPaid
 */

export class Invoice extends Model {

    static reducer(action, Self, session) {
        switch (action.type) {
        case invoiceActions.save:
            invoiceReducers.save(session, action.invoice);
            break;
        case invoiceActions.remove:
            invoiceReducers.remove(session, action.id);
            break;
        case invoiceActions.addItem:
            invoiceReducers.addItem(session, action.id, action.item);
            break;
        case invoiceActions.removeItem:
            invoiceReducers.removeItem(session, action.id, action.itemId);
            break;
        case invoiceActions.setDiscount:
            invoiceReducers.setDiscount(session, action.id, action.discount);
            break;
        case invoiceActions.removeDiscount:
            invoiceReducers.removeDiscount(session, action.id);
            break;
        default:
            return undefined;
        }
    }

    toString() {
        return `Invoice: ${this.id}`
    }
}

Invoice.modelName = 'Invoice';

Invoice.fields = {
    id: attr(),
    invoiceItems: many('InvoiceItem'),
    discount: attr(),
    amount: attr(),
    isPaid: attr(),
    attachments: many('Attachment'),
}

/**
 * InvoiceItem
 * @typedef {Object} InvoiceItem
 * @property {string} id
 * @property {string} title
 * @property {string} image
 * @property {number} discount
 * @property {number} amount
 */

export class InvoiceItem extends Model {

    toString() {
        return `InvoiceItem: ${this.title}`
    }
}

InvoiceItem.modelName = 'InvoiceItem';

InvoiceItem.fields = {
    id: attr(),
    title: attr(),
    image: attr(),
    discount: attr(),
    amount: attr(),
}

